<template>
	<div>
		<template v-if="network_success">
			<!-- banner -->
			<banner :data="banners" @onClick="handleBannerClick"></banner>
			<!-- banner end -->
			
			<!-- 康复案例 -->
			<recovery-case></recovery-case>
			<!-- 康复案例 end -->
			
			<!-- 研发背景 -->
			<Research></Research>
			<!-- 技术支持 end -->
			
			<!-- 合作单位 -->
			<cooperation-unit></cooperation-unit>
			<!-- 合作单位 end -->
			
			<!-- 企业资质 -->
			<qualification v-if="qualifications.length" :data="qualifications"></qualification>
			<!-- 企业资质 end -->
			
			<!-- 视频弹出框 -->
			<screen-video v-model="video_play" :src="video_src"></screen-video>
			<!-- 视频弹出框 end -->
		</template>

		<!-- 网络出错 -->
		<network-err v-if="!network_success" @onRefresh="handleNetworkRefresh"></network-err>
		<!-- 网络出错 end -->
	</div>
</template>

<script>
	import Banner from './components/banner.vue';
	import RecoveryCase from './components/recovery_case.vue';
	import Research from './components/research.vue';
	import CooperationUnit from './components/cooperation_unit.vue';
	import Qualification from './components/qualification.vue';
	import { mapMutations } from 'vuex';
	import Api from '../../../api/api.js';
	
	export default {
		mounted() {
			this.getBanner();
		},
		data() {
			return {
				network_success: true,
				
				banners: [],
				video_play: false,
				video_src: '',
				qualifications: []
			}
		},
		methods: {
			/*************** @Events *******************/
			// 网络错误刷新
			handleNetworkRefresh() {
				this.getBanner();
			},
			// 点击banner图
			handleBannerClick(link) {
				this.video_src = link;
				this.video_play = true;
			},
			
			/*************** @Function *******************/
			// 获取banner
			getBanner() {
				const that = this;
				that.setLoading(true);
				let requestData = {
					limit: null,
					pageNum: null,
					type: 1
				};
				Api.findHomeBanner(requestData).then((res) => {
					if (res.data.success) {
						that.banners = res.data.data || [];
						that.getQualification();
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			// 获取资质
			getQualification() {
				const that = this;
				let requestData = {
					limit: null,
					pageNum: null,
					type: 2
				};
				Api.findHomeBanner(requestData).then((res) => {
					if (res.data.success) {
						that.qualifications = res.data.data || [];
						that.setLoading(false);
						that.network_success = true;
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			
			...mapMutations({
				'setLoading': 'setLoading'
			})
		},
		components: {
			Banner,
			RecoveryCase,
			Research,
			CooperationUnit,
			Qualification
		}
	}
</script>

<style scoped>
</style>
